import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { AppComponent } from './app/app.component';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CoreEffects } from './app/store/core.effects';
import { EffectsModule } from '@ngrx/effects';
import { reducers } from './app/store/core.state';
import { StoreModule } from '@ngrx/store';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { provideRouter } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { routes } from './app/app.route';

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      BrowserModule,
      MatIconModule,
      MatSnackBarModule,
      FormsModule,
      MatSelectModule,
      MatAutocompleteModule,
      MatButtonModule,
      MatDividerModule,
      MatToolbarModule,
      MatFormFieldModule,
      MatInputModule,
      MatProgressBarModule,
      MatTooltipModule,
      StoreModule.forRoot(reducers),
      EffectsModule.forRoot([CoreEffects]),
      StoreDevtoolsModule.instrument({ maxAge: 25 }),
    ),
    provideHttpClient(),
    provideAnimations(),
    provideRouter(routes),
  ],
}).catch((err) => console.error(err));
